module.exports = __webpack_public_path__ + "assets/search-cross.a18c0edb.svg";